// extracted by mini-css-extract-plugin
export default {"btop":"a9643b70c2 _5c58b2ed4d _2d02751c99","icon":"_2027176543 b16d2c515a","btoppink":"_3b5952c99a a64db7a1b6"};